module.exports = __webpack_public_path__ + "img/10020.735ecb4f.jpg";